import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useGalleryStore = defineStore('gallery', () => {
  const currentIndex = ref<number>(0);

  const metaViewportElement = document.getElementById('meta-viewport') as HTMLMetaElement;

  const setCurrentIndex = (newIndex: number) => {
    currentIndex.value = newIndex;
  };

  const isNextIndex = (index: number) => currentIndex.value + 1 === index;

  const makeScalable = (): void => {
    metaViewportElement.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=yes');
  };

  const makeUnscalable = (): void => {
    metaViewportElement.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
  };

  return {
    currentIndex,
    setCurrentIndex,
    isNextIndex,
    makeScalable,
    makeUnscalable,
  };
});
